import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtmParameters } from '@models/UtmParameters';
import { IPartnerData } from '@models/WhitelabelConfig';
import { Observable } from 'rxjs';

import { getCdnAsset, getEndpoint, RESOURCES } from './constants/api-endpoints';

@Injectable({
	providedIn: 'root',
})
export class WhitelabelService {

	constructor(private readonly http: HttpClient) { }

	public getPartnerData(id: string, utmParams?: UtmParameters): Observable<IPartnerData> {
		if (utmParams) {
			const { source, medium, campaign } = utmParams || {};

			return this.http.get<IPartnerData>(
				`${getEndpoint(RESOURCES.PARTNER)}?id=${id}&utmSource=${source}&utmMedium=${medium}&utmCampaign=${campaign}`
			);
		}

		return this.http.get<IPartnerData>(`${getEndpoint(RESOURCES.PARTNER)}?id=${id}`);
	}

	public setWhitelabelStylesheet(brand: string, styleSheetLocation: string): void {
		const formattedBrand: string = brand.toLowerCase();
		const whitelabelStylesheet: HTMLElement | null = document.getElementById('whitelabelStylesheet');
		if (['embrace', ''].includes(formattedBrand) || styleSheetLocation === '') {
			whitelabelStylesheet?.remove();

			return;
		}
		/** Removes previous className on body tag */
		document.body.className = '';
		whitelabelStylesheet?.remove();
		const stylesheetHref: string = getCdnAsset(styleSheetLocation);
		const stylesheetLinkTag: HTMLLinkElement = document.createElement('link');
		stylesheetLinkTag.id = 'whitelabelStylesheet';
		stylesheetLinkTag.setAttribute('rel', 'stylesheet');
		stylesheetLinkTag.setAttribute('href', stylesheetHref);
		document.body.classList.add(`t--${formattedBrand}`);
		document.head.append(stylesheetLinkTag);
	}
}
